import { el, list, setAttr } from 'https://cdn.venturz.co/lib/redom.es.js';

import {
  applyTraits
} from '/programs/utilities/language.js';

import { SelectInputValueSetter, SelectInputValueGetter } from '../traits/value-accessors.js';

import Option from './option.js';

class SelectInputRenderer {

  constructor() {

    this.input = null;

    this.el = el('.form-editor-select-input-renderer', [
      this.renderInput()
    ]);

  }

  renderInput() {

    this.input = list('select.single-select-input', Option);

    return this.input;

  }

  update(inputOptions, fieldRow) {

    const required = inputOptions.required;

    setAttr(this.input, {
      required,
      placeholder: inputOptions.placeholder || '',
      name: fieldRow.label
    });

    const options = ['', ...inputOptions.options];

    this.input.update(options, inputOptions);

  }

}

export default applyTraits(SelectInputRenderer, [SelectInputValueSetter, SelectInputValueGetter]);